import React, { Component } from 'react';
import Iterator from '../core/Iterator';
import ParameterErrors from '../errors/ParameterErrors';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import Marzipano from 'marzipano';
import Hotspot from './Hotspot';
import eventEnable from '../core/eventEnable';
import './View360.css';
const{throwNotProvided}=ParameterErrors;
export default class View360 extends Component {
	constructor(props){
		const {getIconUrlFromRelativePath, onClickHotspot, children, mapHotspotTypeToFactory}=props;
		super(props);
		eventEnable(this);
		this._children = children;
		this._mapHotspotTypeToFactory = mapHotspotTypeToFactory===undefined||mapHotspotTypeToFactory===null?{}:mapHotspotTypeToFactory;
		if(getIconUrlFromRelativePath===undefined||getIconUrlFromRelativePath===null)
			throwNotProvided('getIconUrlFromRelativePath');
		this._getIconUrlFromRelativePath=getIconUrlFromRelativePath;
		this._callbackClickHotspot = onClickHotspot;
		this._viewer360Ref = React.createRef();
		this._createImageUrlSources= this._createImageUrlSources.bind(this);
		this._createLayers = this._createLayers.bind(this);
		this._handleSceneTransitionUpdate = this._handleSceneTransitionUpdate.bind(this);
		this._createMarzipanoScene = this._createMarzipanoScene.bind(this);
		this._createTileUrl = this._createTileUrl.bind(this);
		this._sourceFromTile = this._sourceFromTile.bind(this);
		this._createHotspots = this._createHotspots.bind(this);
		this._createHotspotFromFactory= this._createHotspotFromFactory.bind(this);
		this.loadScene= this.loadScene.bind(this);
		this._handleSceneTransitionDone = this._handleSceneTransitionDone.bind(this);
		this._handleHotspotClick= this._handleHotspotClick.bind(this);
		this._hookUpdateEvent= this._hookUpdateEvent.bind(this);
		this._setCameraDirectionEulerAngles = this._setCameraDirectionEulerAngles.bind(this);
		this._cancelCurrentLoadScene = null;
		this.state = {};
	}
	
    componentDidMount(){
        const viewerOptions = {
            stageType: 'webgl',
            controls: {
                mouseViewMode: 'drag' // drag|qtvr
            },
            stage: {
                antialias: true,
                preserveDrawingBuffer: true,
                generateMipmaps: false
            }
        }
		const viewerElement = this._viewer360Ref.current;
        this._marzipanoViewer = new Marzipano.Viewer(viewerElement, viewerOptions);
        this._limiter = Marzipano.RectilinearView.limit.traditional(1024, 120*Math.PI/180, 120*Math.PI/180);
	}
	_createMarzipanoScene(scene360, cameraDirectionEulerAngles){
		const imageUrlSources = this._createImageUrlSources(scene360);
		const rectilinearView = new Marzipano.RectilinearView({yaw:cameraDirectionEulerAngles?cameraDirectionEulerAngles.yawRadians:undefined}, this._limiter );
		const marzipanoScene = this._marzipanoViewer.createEmptyScene({view: rectilinearView});
		if(this._unhookCurrentUpdateEvent){
			this._unhookCurrentUpdateEvent();
			this._unhookCurrentUpdateEvent = null;
		}
		this._unhookCurrentUpdateEvent = this._hookUpdateEvent(
			this._marzipanoViewer, marzipanoScene,  scene360.cameraEulerAngles);
		this._createLayers(marzipanoScene, imageUrlSources, scene360.getLevels());
		this._createHotspots(marzipanoScene, scene360);
		return marzipanoScene;
	}
	_hookUpdateEvent(marzipanoViewer, marzipanoScene, eulerAngles){
		const self = this;
		const oldUpdate = marzipanoViewer._renderLoop._boundLoop;
		const newLoop = function(props){
			oldUpdate(props);
			const yaw = marzipanoScene._view._yaw-((eulerAngles?eulerAngles.yawRadians:0) + 1.57079);
			self.dispatchEvent({type:'scenemoved', yaw:yaw});
		};
		marzipanoViewer._renderLoop._boundLoop = newLoop;
		return ()=>{
			marzipanoViewer._renderLoop._boundLoop = oldUpdate;
		};
	}
	/*
		*/
	_createTileUrl(face, z, x, y){
		return `${face}/${z}/${y}/${x}.jpg`;
	}
	_createImageUrlSources(scene360){
		const imageUrlSources = [];
		scene360.layers.forEach((scene360Layers)=>{
			scene360Layers.choices.forEach((scene360LayerChoice)=>{
				const imageUrlSource = new Marzipano.ImageUrlSource((tile)=>this._sourceFromTile(
					tile, scene360, scene360Layers, scene360LayerChoice
				));
				imageUrlSources.push(imageUrlSource);
			});
		}); 
		return imageUrlSources;		
	}
	_sourceFromTile(tile, scene360, scene360Layer, scene360LayerChoice){
		let urlPrefix = `${scene360.urlPrefix}${scene360Layer.slug}/`;
		if(scene360LayerChoice.slug!==undefined&&scene360LayerChoice.slug!==null)
			urlPrefix+=`${scene360LayerChoice.slug}/`;
		let res;
		//if (tile.z === 0) {
		//	var mapY = 'bfrlud'.indexOf(tile.face) / 6;
		//	res = { url: `${urlPrefix}preview.png`, rect: { x: 0, y: mapY, width: 1, height: 1/6 }};
		//}
		//else
			res =  { url: `${urlPrefix}${this._createTileUrl(tile.face, tile.z, tile.x, tile.y)}` };	
		return res;
	}
	_createLayers(marzipanoScene, imageUrlSources, levels){
        const marzipanoCubeGeometry = new Marzipano.CubeGeometry(levels);
		for (const imageUrlSource of imageUrlSources) {
			marzipanoScene.createLayer({
				source: imageUrlSource,
				geometry: marzipanoCubeGeometry,
				pinFirstLevel: true
			});
		};
	}
	_createHotspots(marzipanoScene, scene360){
		const self = this;
		scene360.hotspots.forEach(function(scene360Hotspot) {
			if(scene360Hotspot.enabled===false)return;
			if(scene360Hotspot.fromFactory){
				this._createHotspotFromFactory({scene360Hotspot:scene360Hotspot, scene360:scene360, marzipanoScene:marzipanoScene, 
				getIconUrlFromRelativePath:self._getIconUrlFromRelativePath,
				onClick:self._handleHotspotClick});
				return;
			}
			new Hotspot({scene360Hotspot:scene360Hotspot, scene360:scene360, marzipanoScene:marzipanoScene, 
			getIconUrlFromRelativePath:self._getIconUrlFromRelativePath,
				onClick:self._handleHotspotClick});
		});
	}
	_createHotspotFromFactory(scene360Hotspot){
		const factoryMethod = this._mapHotspotTypeToFactory[scene360Hotspot.type];
		return factoryMethod(scene360Hotspot);
	}
	_handleHotspotClick(hotspot){
		this._callbackClickHotspot(hotspot);
	}

	_handleSceneTransitionDone() {
		if (this._marzipanoViewer.listScenes().length <= 1) return;
		this._marzipanoViewer.destroyScene(this._marzipanoViewer.listScenes().shift());
	}

    loadScene(params){
		const {scene360, cameraDirectionEulerAngles}=params;
		if(!scene360)throwNotProvided('scene360');
		const self = this;
		this._cancelCurrentLoadScene&&this._cancelCurrentLoadScene();
		let cancelled = false;
		this._cancelCurrentLoadScene =()=>{cancelled = true;};
		return new Promise((resolve, reject)=>{
			const doRejectBecauseCancelled = ()=>{
				reject(new Error('cancelled because another scene then started loading'));
			};
			if(cancelled)return doRejectBecauseCancelled();
			this._marzipanoViewer.updateSize();
			const marzipanoScene = this._createMarzipanoScene(scene360, cameraDirectionEulerAngles);
			const layers = marzipanoScene.listLayers();
			const iteratorLayers = new Iterator(layers);
			const next = ()=>{
				if(cancelled)return doRejectBecauseCancelled();
				if(!iteratorLayers.hasNext()){
					self._switchToScene(marzipanoScene).then(()=>{
						if(cancelled)return doRejectBecauseCancelled();
						self._marzipanoViewer.updateSize();
						resolve();
					}).catch(reject);
					return;
				}
				const layer = iteratorLayers.next();
				this._loadLayer(layer)
					.then(next).catch(reject);
			};
			next();
		});
	}
	_setCameraDirectionEulerAngles(marzipanoScene, eulerAngles){
			marzipanoScene.setYaw(eulerAngles.yawRadians);
	}
	_switchToScene(marzipanoScene){
		return new Promise((resolve, reject)=>{
			try{
				marzipanoScene.switchTo({
					transitionDuration: 1000,
					transitionUpdate: this._handleSceneTransitionUpdate
				},()=>{
					this._handleSceneTransitionDone();
					resolve();
				});
			}
			catch(err){
				reject(err);
			}
		});
	}
	_handleSceneTransitionUpdate(val, newScene, oldScene) {
		const layers = newScene.listLayers();
		layers.forEach(function(layer, index) {
			const newVal = (val * layers.length) + (index+1 - layers.length);
			const opacity = Marzipano.util.clamp(newVal, 0, 1);
			layer.mergeEffects({ opacity: opacity });
		});
		newScene._hotspotContainer.domElement().style.opacity = val;
		//newScene._hotspotContainer.domElement().style.display="block";
	}
    _loadLayer(layer){
		const textureStore = layer.textureStore();
		return new Promise ((resolve, reject)=>{
			textureStore.addEventListener('textureLoad', tile => {
				resolve();
			});
			textureStore.addEventListener('textureError', reject);
		});
	}
	render() {
		return (<div className="view-360" ref={this._viewer360Ref}>
			{this._children}
		</div>);
	}
}
//TODO check where viewere.destroy was and add in.
